import { ref, computed } from 'vue';

export default (isHovered = false) => {
  const hovered = ref(isHovered);
  const classes = computed(() => ({
    'c-input-hover': hovered.value,
  }));
  return { hovered, classes };
};
